var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardwriteoffratio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 37,
    viewBox: "0 0 27 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5898 3.48474H0V36.1065H26.5898V3.48474Z",
    fill: "#C23700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2945 3.48474H0V36.1065H13.2945V3.48474Z",
    fill: "#FF9755"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3793 5.69531H2.21063V33.8959H24.3793V5.69531Z",
    fill: "#FEDFB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2946 5.69531H2.21063V33.8959H13.2946V5.69531Z",
    fill: "#FFF1D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7682 21.946H12.5887V30.2166H15.7682V21.946Z",
    fill: "#FF4962"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0471 17.5249H7.86755V30.2166H11.0471V17.5249Z",
    fill: "#26D9DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.49 19.7356H17.3105V30.2167H20.49V19.7356Z",
    fill: "#FBB500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32782 31.3219V16.4193H6.53842V29.1106L22.2611 29.1059L22.2616 31.3165L4.32782 31.3219Z",
    fill: "#C23700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7638 2.46927C15.7638 1.10555 14.6583 0 13.2946 0C11.9308 0 10.8253 1.10555 10.8253 2.46927H7.5401V6.71085H19.0491V2.46927H15.7638Z",
    fill: "#DADADA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4901 8.57202H5.43304V10.7826H20.4901V8.57202Z",
    fill: "#C23700"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4901 12.2563H5.43304V14.4669H20.4901V12.2563Z",
    fill: "#C23700"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2946 0C11.9308 0 10.8253 1.10555 10.8253 2.46927H7.5401V6.71085H13.2945L13.2946 0Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2946 5.40371C14.061 5.40371 14.6823 4.78238 14.6823 4.01594C14.6823 3.2495 14.061 2.62817 13.2946 2.62817C12.5281 2.62817 11.9068 3.2495 11.9068 4.01594C11.9068 4.78238 12.5281 5.40371 13.2946 5.40371Z",
    fill: "#C23700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardwriteoffratio);
export default __webpack_public_path__ + "static/media/dashboardwriteoffratio.cb560f029931c95583d8e319d0769326.svg";
export { ForwardRef as ReactComponent };